export * from './input-allowed-symbols.directive';
export * from './input-allowed-symbols.module';
